import React from "react";
import { H4, Text } from "../../typography";
import { StatusEnum } from "../../../hoc/with-status";
import { BADGE_PHOTO } from "../../../config/tasks";
import ProgressRing from "../../screening-results/progress-ring.svg";
import { Row } from "@amzn/stencil-react-components/layout";
import useArb from "../../../hooks/use-arb";

interface CardTextContentProps {
  taskTitleText: string;
  taskName?: string;
  status?: StatusEnum;
  shouldOverrideStatus?: Record<string, StatusEnum>;
  duration?: number;
}
export const TaskCardTextContent = ({
  taskTitleText,
  taskName,
  status,
  shouldOverrideStatus,
  duration,
}: CardTextContentProps) => {
  const bundle = useArb("HVHChecklistPantherResource");
  const translatedApprovalPending = bundle.getMessage(
    "checklist-General-Approval-Pending"
  );
  const timeComplete = bundle.formatMessage("checklist-General-Mins", {
    minutes: duration,
  });
  const translatedActionRequired = bundle.getMessage(
    "checklist-General-TaskStatus-ActionRequired"
  );
  const translatedNotStarted = bundle.getMessage(
    "checklist-General-TaskStatus-NotStarted"
  );
  const translatedError = bundle.getMessage(
    "checklist-General-TaskStatus-Error"
  );
  const translatedNotAvailableYet = bundle.getMessage(
    "checklist-General-TaskStatus-NotAvailableYet"
  );
  const translatedInProgress = bundle.getMessage(
    "checklist-General-TaskStatus-InProgress"
  );

  const overrideStatus =
    status && shouldOverrideStatus && shouldOverrideStatus[status]
      ? shouldOverrideStatus[status]
      : status;
  if (overrideStatus == StatusEnum.COMPLETED) {
    const completedTask = (
      <H4 color="neutral100" fontWeight={500}>
        {taskTitleText}
      </H4>
    );

    switch (taskName) {
      case BADGE_PHOTO:
        return (
          <>
            {completedTask}
            {status === StatusEnum.IN_PROGRESS && (
              <Row gridGap={"0.3rem"}>
                <img
                  width={"24px"}
                  height={"24px"}
                  src={ProgressRing}
                  alt={"progress-ring"}
                />
                <Text color="neutral70" fontWeight={400}>
                  {translatedApprovalPending}
                </Text>
              </Row>
            )}
          </>
        );
      default:
        return completedTask;
    }
  }

  // apply status translation
  let overrideStatusText = overrideStatus?.toString();
  switch (overrideStatus) {
    case StatusEnum.ACTION_REQUIRED: {
      overrideStatusText = translatedActionRequired;
      break;
    }
    case StatusEnum.NOT_STARTED: {
      overrideStatusText = translatedNotStarted;
      break;
    }
    case StatusEnum.ERROR: {
      overrideStatusText = translatedError;
      break;
    }
    case StatusEnum.NOT_AVAILABLE_YET: {
      overrideStatusText = translatedNotAvailableYet;
      break;
    }
    case StatusEnum.IN_PROGRESS: {
      overrideStatusText = translatedInProgress;
      break;
    }
  }

  return (
    <>
      <H4 color="neutral100" fontWeight={500}>
        {taskTitleText}
      </H4>
      <Text color="neutral70" fontWeight={400}>
        {duration && timeComplete}
      </Text>
      <Text color="neutral70" fontWeight={400}>
        {overrideStatusText}
      </Text>
    </>
  );
};
